import makeStyles from "@mui/styles/makeStyles";

export const useStickyStyles = makeStyles({
  sticky: {
    maxHeight: "calc(100vh - 270px)",
    overflowY: "auto",
  },
});
